import { GradientLayout } from "../common/DefaultLayout";
import { ACTIVE_ROUNDS_FILTER, ROUNDS_ENDING_SOON_FILTER, RoundStatus, useFilterRounds } from "./hooks/useFilterRounds";
import { getEnabledChains } from "../../app/chainConfig";
import { useMemo } from "react";
import { filterOutPrivateRounds, filterRoundsWithProjects } from "../api/rounds";
import { RoundsGrid } from "./RoundsGrid";
import LandingHero from "./LandingHero";
import { LandingSection, ViewAllLink } from "./LandingSection";
import { toQueryString } from "./RoundsFilter";
// Note: use during grants rounds or when we figure out how to use all the time.
import { useCollections } from "../collections/hooks/useCollections";
import { CollectionsGrid } from "../collections/CollectionsGrid";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const LandingPage = () => {
  const activeRounds = useFilterRounds(ACTIVE_ROUNDS_FILTER, getEnabledChains(), true);
  const roundsEndingSoon = useFilterRounds(ROUNDS_ENDING_SOON_FILTER, getEnabledChains(), true);
  const filteredActiveRounds = useMemo(() => {
    var _activeRounds$data;
    return filterRoundsWithProjects(filterOutPrivateRounds((_activeRounds$data = activeRounds.data) !== null && _activeRounds$data !== void 0 ? _activeRounds$data : []));
  }, [activeRounds.data]);
  const filteredRoundsEndingSoon = useMemo(() => {
    var _roundsEndingSoon$dat;
    return filterRoundsWithProjects(filterOutPrivateRounds((_roundsEndingSoon$dat = roundsEndingSoon.data) !== null && _roundsEndingSoon$dat !== void 0 ? _roundsEndingSoon$dat : []));
  }, [roundsEndingSoon.data]);
  const collections = useCollections();
  return /*#__PURE__*/_jsxs(GradientLayout, {
    showWalletInteraction: true,
    showAlloVersionBanner: false,
    children: [/*#__PURE__*/_jsx(LandingHero, {}), /*#__PURE__*/_jsx(LandingSection, {
      title: "Community collections",
      children: collections.data !== undefined && /*#__PURE__*/_jsx(CollectionsGrid, {
        data: collections.data
      })
    }), /*#__PURE__*/_jsx(LandingSection, {
      title: "Donate now",
      action: /*#__PURE__*/_jsx(ViewAllLink, {
        to: `/rounds?${toQueryString(ACTIVE_ROUNDS_FILTER)}`,
        children: "View all"
      }),
      children: /*#__PURE__*/_jsx(RoundsGrid, {
        ...activeRounds,
        data: filteredActiveRounds.sort((a, b) => b.matchAmountInUsd - a.matchAmountInUsd),
        loadingCount: 4,
        maxCount: 6,
        getItemClassName: (_, i) => `${i % 3 && i % 4 ? "" : "md:col-span-2"}`,
        roundType: "active"
      })
    }), /*#__PURE__*/_jsx(LandingSection, {
      title: "Rounds ending soon",
      action: /*#__PURE__*/_jsx(ViewAllLink, {
        to: `/rounds?${toQueryString({
          orderBy: ROUNDS_ENDING_SOON_FILTER.orderBy,
          status: `${RoundStatus.active},verified`
        })}`,
        children: "View all"
      }),
      children: /*#__PURE__*/_jsx(RoundsGrid, {
        isLoading: roundsEndingSoon.isLoading,
        data: filteredRoundsEndingSoon,
        loadingCount: ROUNDS_ENDING_SOON_FILTER.first,
        maxCount: ROUNDS_ENDING_SOON_FILTER.first,
        roundType: "endingSoon"
      })
    })]
  });
};
export default LandingPage;